module.exports = __webpack_public_path__ + "static/media/Kreuzgang_tn.bf6916c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sizilien/Kreuzgang_tn.jpg
// module id = 762
// module chunks = 0